import type { MessagingGetChatRooms200Page } from './messagingGetChatRooms200Page';

/**
 * 채팅방 목록 응답 데이터
 */
export type MessagingGetChatRooms200 = {
  code?: string;
  message?: string;
  page?: MessagingGetChatRooms200Page;
  success?: boolean;
};
